import { render, staticRenderFns } from "./emergencyManagement.vue?vue&type=template&id=d68db670&scoped=true"
import script from "./emergencyManagement.vue?vue&type=script&lang=js"
export * from "./emergencyManagement.vue?vue&type=script&lang=js"
import style0 from "./emergencyManagement.vue?vue&type=style&index=0&id=d68db670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68db670",
  null
  
)

export default component.exports